import { jwtDecode } from "jwt-decode";

const DAY_MS = 24 * 60 * 60 * 1000;

function normalizarTexto(valor) {
  return String(valor || "").trim();
}

function formatarData(timestampMs) {
  if (!timestampMs) return "Indisponivel";

  const data = new Date(timestampMs);

  if (Number.isNaN(data.getTime())) return "Indisponivel";

  return new Intl.DateTimeFormat("pt-MZ", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(data);
}

function lerExpiracao(token) {
  if (!token) return null;

  try {
    const dados = jwtDecode(token);
    return dados?.exp ? dados.exp * 1000 : null;
  } catch {
    return null;
  }
}

function formatarPeriodo(validadeusuario) {
  const texto = normalizarTexto(validadeusuario);
  const textoLower = texto.toLowerCase();

  if (!texto) return "Mensal";
  if (textoLower === "3 meses") return "Trimestral";
  if (textoLower.includes("trimestral")) {
    return texto.replace(/\s*trimestral/i, "");
  }
  if (textoLower.includes("mensal")) {
    return texto.replace(/\s*mensal/i, "");
  }

  return texto;
}

export function getSubscriptionInfo(usuario = {}) {
  const plano = normalizarTexto(usuario.profileusuario || usuario.profile);
  const profileAtual = normalizarTexto(usuario.profile);
  const planoNormalizado = plano.toUpperCase();
  const desativado =
    normalizarTexto(usuario.disabled).toLowerCase() === "true" ||
    profileAtual.toUpperCase() === "DESATVADO" ||
    planoNormalizado === "DESATVADO";

  const expiracaoMs = lerExpiracao(usuario.token);
  const agora = Date.now();
  const tokenExpirado = expiracaoMs ? expiracaoMs <= agora : false;
  const diasRestantes = expiracaoMs
    ? Math.max(0, Math.ceil((expiracaoMs - agora) / DAY_MS))
    : null;
  const temPlano = Boolean(plano && planoNormalizado !== "DESATVADO");
  const activo = temPlano && !desativado && !tokenExpirado;
  const periodo = formatarPeriodo(usuario.validadeusuario);
  const preco = usuario.precousuario ? `${Number(usuario.precousuario).toLocaleString("pt-MZ")} MZN` : "Indisponivel";

  if (activo) {
    return {
      planLabel: plano,
      statusLabel: "Activo",
      statusTone: "green",
      isActive: true,
      periodLabel: periodo,
      priceLabel: preco,
      expiryLabel: formatarData(expiracaoMs),
      daysLabel: diasRestantes === null ? "Sem data" : `${diasRestantes} dias`,
      shouldRenewSoon: diasRestantes !== null && diasRestantes <= 5,
    };
  }

  if (temPlano && !expiracaoMs && !desativado) {
    return {
      planLabel: plano,
      statusLabel: "A confirmar",
      statusTone: "amber",
      isActive: false,
      periodLabel: periodo,
      priceLabel: preco,
      expiryLabel: "Sem data",
      daysLabel: "Sem token",
      shouldRenewSoon: false,
    };
  }

  return {
    planLabel: temPlano ? plano : "Sem plano activo",
    statusLabel: "Subscricao terminada",
    statusTone: "red",
    isActive: false,
    periodLabel: periodo,
    priceLabel: preco,
    expiryLabel: formatarData(expiracaoMs),
    daysLabel: "Expirada",
    shouldRenewSoon: false,
  };
}

export function getStatusClasses(tone) {
  const classes = {
    green: "border-emerald-200 bg-emerald-50 text-emerald-700",
    amber: "border-amber-200 bg-amber-50 text-amber-700",
    red: "border-red-200 bg-red-50 text-red-700",
  };

  return classes[tone] || classes.amber;
}
